module.exports = __webpack_public_path__ + "static/media/ghost.19685a16.mp3";